import React, { useEffect, useRef } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import '../css/man-power-supply.css';

function Home() {
    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50); // Delay before animation starts
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {/* Section 1: Mission & Vision */}
            <div className="container-fluid about-bg3 d-flex align-items-end mb-5" style={{ padding: 0, top: '-122px' }}>
                <div className="container-fluid align-items-center justify-content-center about-content">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="d-flex flex-column flex-md-row align-items-start ms-5">
                                <div className="me-md-5">
                                    <h1 className="about-title">Specialized Drilling Personnel</h1>
                                    <h2 className="about-subtitle">And Performance Specialists</h2>
                                    <div className="about-underline" ref={underlineRef}></div>
                                </div>
                                <div>
                                    <p className="about-desc ms-5 align-items-center" style={{ fontSize: 19 }}>
                                        Petrochoice provide a comprehensive team of specialized drilling personnel and performance specialists, including rig crew members, who are crucial to optimizing drilling operations, minimizing lost time, and reducing costs. Our diverse team comprises experts in various drilling aspects, ensuring that we offer comprehensive support and expertise throughout the drilling process.                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Section 2: Specialized Drilling Personnel */}
            <div className="container my-5">
                <h3 className="title mb-4">Specialized Drilling Personnel and Performance Specialists</h3>
                <div className="row">
                    {[
                        {
                            title: "Drilling Engineers",
                            delay: 0,
                            desc: "Our drilling engineers are highly skilled professionals with extensive experience in planning and executing drilling operations. They design safe and efficient well programs, monitor drilling performance, and implement best practices to optimize safety, reduce costs, and enhance operational efficiency."
                        },
                        {
                            title: "Drilling SuperIntendents",
                            delay: 100,
                            desc: "Our drilling superintendents are experienced leaders responsible for overseeing all drilling operations. They ensure that projects are executed safely, efficiently, and in compliance with company standards. By coordinating between on-site teams and engineering departments, they optimize performance, manage resources, and drive operational excellence across all drilling activities."
                        },
                        {
                            title: "Drilling/Workover Supervisors",
                            delay: 200,
                            desc: "Drilling and workover supervisors manage and coordinate all rig-site operations, ensuring safety, efficiency, and adherence to project plans. Their leadership and technical expertise enable seamless execution of drilling and workover activities while minimizing risks and optimizing performance."
                        },
                        {
                            title: "Drilling Fluid Specialists",
                            delay: 300,
                            desc: "Drilling fluid specialists manage the formulation, testing, and maintenance of drilling fluids to ensure safe and efficient drilling operations. They ensure proper fluid properties for hole stability, hole cleaning, and environmental protection, optimizing drilling efficiency and minimizing risks."
                        },
                        {
                            title: "Rig Crew Members",
                            delay: 400,
                            desc: "Our rig crew members, including drillers and toolpushers, are essential for operating drilling equipment. They ensure smooth operations, maintain rig services, and support emergency procedures, contributing to the overall success of drilling projects."
                        },
                        {
                            title: "Cementing Specialists",
                            delay: 500,
                            desc: "Cementing specialists ensure wellbore integrity through expert cement placement optimization. They design cement slurries and manage long-term well management, preventing formation fluid migration and ensuring zonal isolation."
                        },
                        {
                            title: "Well Site Geologists",
                            delay: 600,
                            desc: "Well site geologists provide critical subsurface formation analysis and geological complexity assessment. They offer insights for wellsites positioning strategy and hydrocarbon recovery, enhancing reservoir engineering and long-term management of drilling projects."
                        },
                        {
                            title: "Drilling Bit Specialists",
                            delay: 700,
                            desc: "Drilling bit specialists manage the selection, maintenance, and performance of drilling bits to optimize drilling efficiency and hole stability. They ensure proper bit selection for different formation types, maintain bit performance, and implement best practices for bit selection and replacement, enhancing drilling productivity and minimizing costs."
                        },
                        {
                            title: "Completion Specialists",
                            delay: 800,
                            desc: "Completion specialists specialize in well-completion design and operations. They have comprehensive knowledge of completion techniques, downhole equipment, and well-stimulation methods. Their expertise ensures the successful completion of wells, maximizing production potential and optimizing reservoir performance."
                        },
                        {
                            title: "Well Control Specialists",
                            delay: 900,
                            desc: "Well control specialists are responsible for maintaining wellbore integrity and managing well control incidents during drilling operations. They possess in-depth knowledge of well control principles, equipment, and emergency procedures. Their expertise ensures safe and effective well control, minimizing risks and ensuring operational safety."
                        },

                    ].map((item, i) => (
                        <div key={i} className="col-lg-4 col-md-6 col-12 mb-4" data-aos="fade-up" data-aos-delay={item.delay}>
                            <div className="card h-100 border-0 shadow-sm">
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px' }}>
                                            <i className="fas fa-user-tie text-white"></i>
                                        </div>
                                        <h5 className="card-title mb-0 fw-bold" style={{ color: '#0c61c0' }}>{item.title}</h5>
                                    </div>
                                    <p className="card-text text-muted" style={{ textAlign: 'justify', lineHeight: '1.6' }}>{item.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <div className="container my-5">
                <div className="row">
                    <div className="col-12">
                        <h3 className="title mb-4 text-center">Additional Specialists</h3>
                        <div className="row">
                            {[
                                {
                                    title: "Material Engineering Specialists",
                                    delay: 0,
                                    desc: "Material engineering specialists focus on optimizing the selection and performance of materials used in drilling operations. They provide guidance on material compatibility, corrosion prevention, and equipment reliability. Their expertise ensures the use of appropriate materials that withstand drilling conditions and enhance operational efficiency."
                                },
                                {
                                    title: "Geology Specialists",
                                    delay: 100,
                                    desc: "Geology specialists play a vital role in drilling operations by providing insights into subsurface formations and geological complexities. They analyze geological data, conduct wellsites assessments, and provide valuable input on wellbore positioning and drilling strategies. Their expertise helps optimize well placement and maximize hydrocarbon recovery."
                                },
                                {
                                    title: "Wellhead Specialists",
                                    delay: 200,
                                    desc: "Wellhead specialists are experts in wellhead equipment design, installation, and maintenance. They provide guidance on wellhead selection, pressure control services, and safety measures. Their expertise ensures the integrity of wellhead services, enhancing safety and operational efficiency."
                                },
                                {
                                    title: "Petroleum Engineering Specialists",
                                    delay: 300,
                                    desc: "Petroleum engineering specialists contribute their expertise in reservoir engineering, production optimization, and well performance analysis. They analyze reservoir characteristics, develop production strategies, and provide recommendations for maximizing hydrocarbon recovery. Their insights are crucial for efficient drilling operations and long-term reservoir management."
                                },
                            ].map((item, i) => (
                                <div key={i} className="col-lg-6 col-md-12 mb-4" data-aos="fade-up" data-aos-delay={item.delay}>
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-body p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-warning rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '50px', height: '50px' }}>
                                                    <i className="fas fa-cogs text-white"></i>
                                                </div>
                                                <h5
                                                    className="fw-bold mb-0"
                                                    style={{ color: '#ED6803', fontFamily: "Raleway" }}
                                                >
                                                    {item.title}
                                                </h5>
                                            </div>
                                            <p className="text-muted" style={{ textAlign: 'justify', lineHeight: '1.6' }}>
                                                {item.desc}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>



        </>
    );
}

export default Home;
